import React from "react";
import { PageProps, graphql } from "gatsby";
import Layout from "@components/common/Layout";
import { HeroBannerPropsModel } from "@models/hero-banner";
import HeroBanner from "@components/common/HeroBanner";
import { SolutionsDynamicZones } from "@models/solutions";
import useDynamicZone from "@hooks/use-dyamic-zone";

export interface SolutionPageDataModel {
  strapiSolution: {
    topBanner: HeroBannerPropsModel;
    dynamicZoneComponents: SolutionsDynamicZones[];
  };
}

const SolutionsPage = (props: PageProps<SolutionPageDataModel>) => {
  const { topBanner, dynamicZoneComponents } =
    props?.data?.strapiSolution ?? {};
  const { renderDynamicZone } = useDynamicZone({});

  return (
    <Layout>
      <HeroBanner {...topBanner} path="" />
      {dynamicZoneComponents?.map((dynamicZone) => {
        const { id } = dynamicZone;
        return <div key={id}>{renderDynamicZone(dynamicZone)}</div>;
      })}
    </Layout>
  );
};

export default SolutionsPage;

export const query = graphql`
  query strapiSolution($id: String) {
    strapiSolution(id: { eq: $id }) {
      id
      slug
      title
      seo {
        ...seoFragment
      }
      topBanner {
        bigHeader
        ctaBtnLink
        ctaBtnText
        description
        topbanner: image {
          localFile {
            childImageSharp {
              gatsbyImageData(width: 575, placeholder: BLURRED, formats: PNG)
            }
          }
        }
        title
      }
      dynamicZoneComponents {
        ... on STRAPI__COMPONENT_COMMON_QUESTION_ANSWER {
          ...questionAnswerFragment
        }
        ... on STRAPI__COMPONENT_COMMON_BENTO_HIGHLIGHTER {
          ...bentoGridFragment
        }
        ... on STRAPI__COMPONENT_COMMON_TIMELINE {
          ...timeLineFragment
        }
        ... on STRAPI__COMPONENT_COMMON_TESTIMONIAL_SLIDER {
          ...testimonialSliderFragment
        }
        ... on STRAPI__COMPONENT_COMMON_LAST_SCROLL_CTA {
          ...lastScrollCtaFragment
          variant
        }
        ... on STRAPI__COMPONENT_COMMON_FEATURE_STATS {
          ...featureStatsFragment
          subTitle
        }
        # ... on STRAPI__COMPONENT_COMMON_HP_STATS {
        #   id
        #   title
        #   strapi_component
        #   bgColor
        #   titles {
        #     title
        #     subTitle
        #     id
        #     icon
        #     color
        #   }
        # }
        ... on STRAPI__COMPONENT_COMMON_FAQ {
          ...faqFragment
        }
        ... on STRAPI__COMPONENT_COMMON_CARD_WRAPPER {
          ...cardWrapperFragment
          cards {
            cardImage: image {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 355, height: 255)
                }
              }
            }
            logoImage: image {
              localFile {
                childImageSharp {
                  gatsbyImageData(height: 72)
                }
              }
            }
          }
        }
      }
    }
  }
`;
